/**
 * Calculates the distance between two points (segment length)
 */
export default function getDistance(a, b) {
  let { x: x1, y: y1 } = a,
    { x: x2, y: y2 } = b

  return Math.sqrt(Math.pow(x1 - x2, 2) + Math.pow(y1 - y2, 2))
}
